import { lazy } from 'react';
import withLoadableComponent from './withLoadableComponent';
export var LoadablePostPopup = withLoadableComponent(lazy(function () {
    return import(
    /* webpackChunkName: "postpopup" */
    '../PostPopup');
}));
export var LoadableWriterPopup = withLoadableComponent(lazy(function () {
    return import(
    /* webpackChunkName: "writerpopup" */
    '../WriterPopup');
}));
export var LoadableCommissionEditPopup = withLoadableComponent(lazy(function () {
    return import(
    /* webpackChunkName: "commissioneditpopup" */
    '../CommissionEditPopup');
}));
export var LoadablePollEditPopup = withLoadableComponent(lazy(function () {
    return import(
    /* webpackChunkName: "polleditpopup" */
    '../PollEditPopup');
}));
//# sourceMappingURL=LoadableModals.js.map